/**
 * Filters an object for children who both have a property and
 * a corresponding value matching input parameters.
 * @param {object}  obj   The object to be filtered.
 * @param {string}  key   The key to search for.
 * @param {*}       value The value to search against
 * @return {object}       The matching items
 */
export default function filterObject(obj, key, value) {
  return Object.keys(obj).reduce((acc, item) => {
    if (Object.prototype.hasOwnProperty.call(obj[item], key) &&
      value === obj[item][key]) {
      acc[item] = obj[item];
    }
    return acc;
  }, {});
}



// WEBPACK FOOTER //
// ./app/utils/object/filterObject.js